import axios, { AxiosRequestHeaders } from 'axios';
import HWLocalStorage from './HWLocalStorage';
import refreshTokenInstance from '../../auth/service/RefreshTokenService';

const hwAxios = axios.create();

hwAxios.interceptors.request.use(
  (config) => {
    if (HWLocalStorage.load('accessToken')) {
      config.headers = {
        Authorization: HWLocalStorage.load('accessToken'),
      } as AxiosRequestHeaders;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

hwAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const originalRequest = error.config;
    const canRefreshToken =
      error.response &&
      error.response.status &&
      (error.response.status === 401);
    const isRetryRequest =
      originalRequest._retry != undefined &&
      originalRequest._retry != null &&
      originalRequest._retry;
    if (canRefreshToken && !isRetryRequest) {
      originalRequest._retry = true;

      return refreshTokenInstance.callRefreshToken(originalRequest);
    }
    // return Error object with Promise

    return Promise.reject(error);
  }
);

export default hwAxios;
